<template>
  <div>
    <card class="w-100">
      <el-row :gutter="10">
        <form @submit.prevent="search()">
          <el-col :span="2">
            <div class="form-group">
              <label>가~하, A~Z</label>
              <el-select v-model="searchCompanyName" placeholder="검색조건을 선택하세요." @change="changeCompanyName" :disabled="checkAuth($store.state.account.roleCode, 'ADVERTISER:AGENT')">
                <el-option
                  v-for="item in keywordOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="form-group">
              <label>광고주</label>
              <el-select v-model="searchParam.companySeq" filterable placeholder="광고주를 선택하세요." @change="changeCompany" :disabled="checkAuth($store.state.account.roleCode, 'ADVERTISER:AGENT')">
                <el-option
                  key="0"
                  value="0"
                  :label="searchCompanyName === '' ? '전체' : '선택'"
                />
                <el-option
                  v-for="item in $store.state.settingsCompany.company"
                  :key="item.companySeq"
                  :label="item.companyName"
                  :value="item.companySeq">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="form-group">
              <label>사업자등록번호</label>
              <el-input v-model="searchParam.licenseNumber" placeholder="사업자등록번호" :disabled="checkAuth($store.state.account.roleCode, 'ADVERTISER')">
              </el-input>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="form-group">
              <label>상품명</label>
              <el-input v-model="searchParam.goodsName" placeholder="상품명">
              </el-input>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="form-group">
              <label>매체구분</label>
              <el-select v-model="searchParam.mediaTypeParam">
                <el-option
                  key=""
                  value=""
                  label="전체"></el-option>
                <el-option
                  key="WC"
                  value="WC"
                  label="와이드칼라"></el-option>
                <el-option
                  key="DM"
                  value="DM"
                  label="디지털미디어"></el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="form-group">
              <label>페이지당 리스트수</label>
              <el-select v-model="searchParam.perPage">
                <el-option
                  key="10"
                  value="10"
                />
                <el-option
                  key="20"
                  value="20"
                />
                <el-option
                  key="30"
                  value="30"
                />
                <el-option
                  key="50"
                  value="50"
                />
                <el-option
                  key="100"
                  value="100"
                />
              </el-select>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="pull-right-top24">
              <el-button type="primary" native-type="submit" icon="el-icon-search">검색</el-button>
              <el-button type="primary" @click="resetPage" icon="el-icon-refresh">초기화</el-button>
            </div>
          </el-col>
        </form>
      </el-row>
    </card>
    <card class="w-100">
      <el-col :span="24">
        <el-table class="table-striped"
                  border
                  style="width: 100%; margin-bottom: 10px"
                  :data="this.advertiserStatus"
                  :header-cell-style="tableRowStyle">
          <el-table-column
            label="전체수량">
            <template slot-scope="props">
              {{ props.row.totalCount | numeral('0,0')}}개
            </template>
          </el-table-column>
          <el-table-column
            label="와이드칼라 수량">
            <template slot-scope="props">
              {{ props.row.wcCount | numeral('0,0')}}개
            </template>
          </el-table-column>
          <el-table-column
            label="디지털미디어 수량">
            <template slot-scope="props">
              {{ props.row.dmCount | numeral('0,0')}}개
            </template>
          </el-table-column>
          <el-table-column
            label="수익">
            <template slot-scope="props">
              {{ props.row.inComingCount | numeral('0,0')}}개
            </template>
          </el-table-column>
          <el-table-column
            label="공실">
            <template slot-scope="props">
              {{ props.row.emptyCount | numeral('0,0')}}개
            </template>
          </el-table-column>
          <el-table-column
            label="제휴">
            <template slot-scope="props">
              {{ props.row.affilizationCount | numeral('0,0')}}개
            </template>
          </el-table-column>
          <el-table-column
            label="PL">
            <template slot-scope="props">
              {{ props.row.plCount | numeral('0,0')}}개
            </template>
          </el-table-column>
          <el-table-column
            label="기타">
            <template slot-scope="props">
              {{ props.row.etcCount | numeral('0,0')}}개
            </template>
          </el-table-column>
          <el-table-column
            label="월 광고료(VAT별도)"
            width="200">
            <template slot-scope="props">
              {{ props.row.sumPrice | numeral('0,0')}}원
            </template>
          </el-table-column>
        </el-table>

        <advertisement-list-component ref="advertisementList" :page-type="pageType" :per-page="parseInt(searchParam.perPage)"
                                      v-on:detailRow="detailRow"></advertisement-list-component>
      </el-col>
      <el-col :span="12">
        <el-button type="primary" icon="el-icon-finished" v-on:click="showModal(true)"
                   v-if="$store.state.account.roleCode === 'ADMIN'">컬럼 선택
        </el-button>
        <el-button type="danger" icon="el-icon-finished" v-if="$store.state.account.roleCode === 'ADMIN'"
                   v-on:click="deleteByIds">선택 삭제
        </el-button>
      </el-col>
      <el-col :span="12" class="pull-right">
        <div class="pull-right">
          <el-button type="primary" icon="el-icon-plus" v-on:click="createOrder"
                     v-if="$store.state.account.roleCode === 'ADMIN'">선택항목 발주관리에 추가
          </el-button>
          <el-button type="primary" icon="el-icon-download" v-on:click="downloadExcel">
            엑셀 다운로드
          </el-button>
        </div>
      </el-col>
    </card>

    <column-selector-modal ref="columnSelectorModal" :page-type="pageType" v-on:closeModal="showModal"
                           v-on:setColumn="setColumn"></column-selector-modal>

  </div>
</template>

<script>
  import Vue from 'vue'
  import {Table, TableColumn, Select, Input, Option, Button, Row, Col} from 'element-ui'
  import AdvertiserProxy from "@/proxies/AdvertiserProxy";
  import OrderProxy from "@/proxies/OrderProxy";
  import AdvertisementListComponent from "../Common/AdvertisementListComponent";
  import ColumnSelectorModal from "../Common/ColumnSelectorModal";
  import MediaProxy from "../../../../proxies/MediaProxy";

  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(Button)
  Vue.use(Row)
  Vue.use(Col)
  Vue.use(Input)

  window.updateComplete = function() {
    let companySeq = localStorage.getItem("companySeq");
    let licenseNumber = localStorage.getItem("licenseNumber");
    let goodsName = localStorage.getItem("goodsName");
    let mediaTypeParam = localStorage.getItem("mediaTypeParam");
    let searchCompanyName = localStorage.getItem("searchCompanyName");
    let page = localStorage.getItem("page");
    localStorage.setItem("reload", "true");
    location.href = "/#/advertiser/management?companySeq="+companySeq+"&licenseNumber="+licenseNumber+"&goodsName="+goodsName+"&mediaTypeParam="+mediaTypeParam+"&searchCompanyName="+searchCompanyName+"&page="+page;
    location.reload();
  };

  export default {
    name: "AdvertiserManagement",
    created: function () {
      if(localStorage.getItem("reload") === "true") {
        this.searchCompanyName = this.$route.query.searchCompanyName;
        if(this.$route.query.companySeq !== "0") {
          this.searchParam.companySeq = parseInt(this.$route.query.companySeq);
        }
        this.searchParam.licenseNumber = this.$route.query.licenseNumber;
        this.searchParam.goodsName = this.$route.query.goodsName;
        this.searchParam.mediaTypeParam = this.$route.query.mediaTypeParam;
        this.searchParam.page = this.$route.query.page;
        this.reload();
        localStorage.setItem("reload", "false");
      }

      this.$store.dispatch('common/setMenuTitle', "광고주 현황");
      this.$store.dispatch('advertiser/initAdvertiserMediaList');
      this.$store.dispatch('settingsCompany/initCompanyList');
      this.getAdvertisers();
    },
    mounted: function () {
      if (this.$store.state.account.roleCode === 'ADVERTISER' || this.$store.state.account.roleCode === 'AGENT') {
        // 광고주인 경우
        this.searchParam.companySeq = this.$store.state.account.companySeq;
        this.search();
      }
    },
    components: {
      AdvertisementListComponent,
      ColumnSelectorModal,
    },
    methods: {
      tableRowFont10Style() {
        return this.$store.state.common.tableHeaderFont10CellStyle;
      },
      tableRowStyle() {
        return this.$store.state.common.tableHeaderCellStyle;
      },
      // 검색
      search() {
        if (this.searchCompanyName !== '' && this.searchParam.companySeq === '0') {
          alert("광고주를 선택해 주세요!");
        } else {
          this.searchParam.page = 1;
          this.reload();
        }
      },
      reload() {
        this.advertiserStatus = [];

        new AdvertiserProxy()
          .getAdvertiserStatus(this.searchParam)
          .then((response) => {
            this.advertiserStatus.push(response.advertiserStatus);
            this.searchParam.rows = this.searchParam.perPage;
            this.$refs.advertisementList.getList(this.searchParam);
          });
      },
      // 광고주 조회
      getAdvertisers() {
        let param = {
          roleCode: "ADVERTISER",
          searchKey: this.searchCompanyName,
          rows: 10000
        };
        this.$store.dispatch('settingsCompany/findAll', param);
      },
      // 업체 선택
      changeCompany(value) {
        this.searchParam.licenseNumber = '';
        this.search();
      },
      // 업체 필터링 조검 변경
      changeCompanyName(value) {
        this.searchParam.companySeq = '0';
        this.getAdvertisers();
      },
      // 발주관리에 추가
      createOrder() {
        this.getMultipleSelections();
        if (this.multipleSelection.length > 0) {
          if (confirm("선택한 항목을 발주관리에 추가하시겠습니까?")) {
            let advertisementArray = [];
            this.multipleSelection.forEach(s => {
              advertisementArray.push({advertisementSeq: s.advertisement_seq})
            });
            new OrderProxy()
              .create({advertisements: advertisementArray})
              .then((response) => {
                if (response.header.returnCode === "OK") {
                  alert("완료되었습니다.")
                } else {
                  alert(response.header.resultMessages);
                }
              })
          }
        } else {
          alert("광고를 선택하세요.");
        }
      },
      // 엑셀 다운로드
      downloadExcel() {
        this.getMultipleSelections();
        if (this.multipleSelection.length > 0) {
          let param = "";
          this.multipleSelection.forEach(s => {
            param += s.advertisement_seq + ",";
          });
          location.href = "/api/store/excel?authorization=" + $cookies.get('id_token') + "&list=" + param;
        } else {
          alert("광고를 선택하세요.");
        }
      },
      // 선택항목 가져오기
      getMultipleSelections() {
        this.multipleSelection = [];
        this.$store.state.advertiser.multipleSelection.forEach(select => {
          if (select !== undefined) {
            select.forEach(row => {
              this.multipleSelection.push(row);
            });
          }
        });
      },
      // 대상 확인창 열기/닫기
      showModal(isShow) {
        this.modals.isShow = isShow;
        if (isShow) {
          this.updateColumn();
          this.$refs.columnSelectorModal.show();
        }
      },
      deleteByIds() {
        this.multipleSelection = this.$refs.advertisementList.getMultipleSelections();
        if (this.multipleSelection.length > 0) {
          if (confirm("선택한 광고를 삭제하시겠습니까?")) {
            let param = "";
            this.multipleSelection.forEach(s => {
              param += s.advertisement_seq + ",";
            });
            new MediaProxy({list: param})
              .deleteByIds()
              .then((response) => {
                this.search();
              })
          }
        } else {
          alert("광고를 선택하세요.");
        }
      },
      // 컬럼선택 완료
      setColumn() {
        this.$refs.advertisementList.findAllByUserIdAndPageType(this.pageType);
        this.showModal(false);
      },
      // 컬럼선택 창에서 컬럼설정 다시 조회
      updateColumn() {
        this.$refs.columnSelectorModal.findAllByUserIdAndPageType();
      },
      // 상세보기
      detailRow(row) {
        if (this.$store.state.account.roleCode === 'ADMIN' || this.$store.state.account.roleCode === 'EMART') {
          localStorage.setItem("companySeq", this.searchParam.companySeq);
          localStorage.setItem("licenseNumber", this.searchParam.licenseNumber);
          localStorage.setItem("goodsName", this.searchParam.goodsName);
          localStorage.setItem("mediaTypeParam", this.searchParam.mediaTypeParam);
          localStorage.setItem("searchCompanyName", this.searchCompanyName);
          localStorage.setItem("page", this.searchParam.page);
          window.open("/#/store/" + row.store_seq + "/advertisement/" + row.advertisement_seq + "?page=advertiser&area_seq=" + row.area_seq + "&id_token=" + $cookies.get('id_token'), "media_edit" + row.advertisement_seq, "width=820, height=1000, status=1, scrollbars=1");
        } else {
          window.open("/#/advertiser/store/" + row.store_seq + "/floor/" + row.store_floor_seq + "/advertisement/" + row.advertisement_seq + "?media_type=" + row.media_type + "&page_type=advertisement" + "&id_token=" + $cookies.get('id_token'), "media_detail" + row.advertisement_seq, "width=820, height=1000, status=1, scrollbars=1");
        }
      },
      // 화면 초기화
      resetPage() {
        location.reload();
      },
      // 권한 확인
      checkAuth(roleCode, targetRoles) {
        return Vue.checkAuth(roleCode, targetRoles);
      }
    },
    data() {
      return {
        advertiserStatus: [],
        header: {
          Authorization: $cookies.get('id_token')
        },
        modals: {
          isShow: false,
        },
        columns: [],
        pageType: 'advertisement',
        keywordOptions: [
          {label: '전체', value: ''},
          {label: '가', value: '가'},
          {label: '나', value: '나'},
          {label: '다', value: '다'},
          {label: '라', value: '라'},
          {label: '마', value: '마'},
          {label: '바', value: '바'},
          {label: '사', value: '사'},
          {label: '아', value: '아'},
          {label: '자', value: '자'},
          {label: '차', value: '차'},
          {label: '카', value: '카'},
          {label: '타', value: '타'},
          {label: '파', value: '파'},
          {label: '하', value: '하'},
          {label: 'A-z', value: 'a'}
        ],
        searchParam: {
          companySeq: "0",
          licenseNumber: '',
          goodsName: '',
          mediaTypeParam: '',
          page: 1,
          perPage: "10",
          rows: "10",
        },
        searchCompanyName: '',
        editParam: {
          areaSeq: '',
          storeSeq: '',
          advertisementSeq: '',
        },
        multipleSelection: [],

      }
    }
  }
</script>

<style>
  .el-select .el-input:hover .el-input__icon, .el-select .el-input:hover input {
    color: #212529 !important;
  }

  .bg-purple-light {
    background: #f8f9fc;
  }
</style>
